// extracted by mini-css-extract-plugin
export default {"customSelect":"A9jR9__customSelect","focus":"tn8Or__focus","error":"kHoRQ__error"};